import { Injectable } from '@angular/core';
import { ServiceLocator, IAppConfig, AttendanceService } from 'portalServices';
import { getWebServiceConfig } from './service.config.web';

import { SpinnerService } from 'portalServices';
import { AuthenticationService } from 'portalServices';
import { AuthStatusService } from 'portalServices';
import { ConfigService } from 'portalServices';
import { InitializationService } from 'portalServices';
import { EmployeeInitializationService } from 'portalServices';

import { DashboardService } from 'portalServices';
import { DownloadService } from 'portalServices';
import { EmployeeService } from 'portalServices';
import { EmployeeSideService } from 'portalServices';
import { HelpDeskService } from 'portalServices';
import { TimeSheetService } from 'portalServices';

/**
 * AppServices � employee portal edition.
 *
 * Exposes only the services the employee-portal needs. All services are
 * backed by the same shared ServiceLocator / HttpProvider as the admin
 * client, so tokens and interceptors are automatically shared.
 *
 * Usage:
 *   constructor(private appServices: AppServices) {}
 *   const profile$ = this.appServices.employeeSideService.employee;
 */
@Injectable({ providedIn: 'root' })
export class AppServices {
    private static isInitialized = false;
    private appConfig: IAppConfig;

    constructor() {
        this.appConfig = getWebServiceConfig();
        if (!AppServices.isInitialized) {
            ServiceLocator.initialize(this.appConfig);
            AppServices.isInitialized = true;
        }
    }

    public get locator(): ServiceLocator {
        return ServiceLocator.getInstance();
    }

    // ??? Tier 1 ??????????????????????????????????????????????????????????????

    get spinnerService(): SpinnerService {
        return this.locator.getSpinnerService();
    }

    get authenticationService(): AuthenticationService {
        return this.locator.getAuthenticationService();
    }

    get configService(): ConfigService {
        return this.locator.getConfigService();
    }

    // ??? Tier 2 ??????????????????????????????????????????????????????????????

    get authStatusService(): AuthStatusService {
        return this.locator.getAuthStatusService();
    }

    get dashboardService(): DashboardService {
        return this.locator.getDashboardService();
    }

    get downloadService(): DownloadService {
        return this.locator.getDownloadService();
    }

     get employeeService(): EmployeeService {
        return this.locator.getEmployeeService();
    }

    get employeeSideService(): EmployeeSideService {
        return this.locator.getEmployeeSideService();
    }

    get helpDeskService(): HelpDeskService {
        return this.locator.getHelpDeskService();
    }

    get timeSheetService(): TimeSheetService {
        return this.locator.getTimeSheetService();
    }

    get attendanceService():AttendanceService{
        return this.locator.getAttendanceService();
    }

    // ??? Tier 3 ??????????????????????????????????????????????????????????????

    /**
     * Employee-specific initialization service. Bootstraps with
     * configByOrg + getEmployee (not the admin getAllAccountManager call).
     * Exposed as InitializationService so the auth guard / app-init service
     * work without changes.
     */
    get initializationService(): InitializationService {
        return this.locator.getEmployeeInitializationService();
    }


    // ??? Lifecycle ???????????????????????????????????????????????????????????

    logout(): void {
        ServiceLocator.destroy();
        AppServices.isInitialized = false;
    }

    getConfig(): IAppConfig {
        return this.appConfig;
    }
}
